import { TEST_SIGNAL_PATHS, type TestSignalPath } from "@visioni/a3s-monitoring/app";

export interface TestSignalAction {
  signalPath: TestSignalPath;
  title: string;
  subtitle: string;
  /** Each press is real traffic to a live ARC, so every action confirms first. */
  confirmMessage: string;
}

const ACTIONS: Readonly<Record<TestSignalPath, TestSignalAction>> = {
  camera: {
    signalPath: "camera",
    title: "Test camera signal",
    subtitle: "The camera uploads a clip to a3s, as it would for a real alarm.",
    confirmMessage:
      "This asks the camera to upload a clip as if it were a real alarm. If the asset is monitored, it reaches the monitoring centre. Continue?",
  },
  va: {
    signalPath: "va",
    title: "Test VA signal",
    subtitle: "Exercises the VA delivery leg. Does nothing on a camera without VA.",
    confirmMessage:
      "This asks VA to produce a clip and deliver it through its own path. If the asset is monitored, it reaches the monitoring centre. Continue?",
  },
};

/** One action per delivery leg, in the order the wire contract lists them. */
export const TEST_SIGNAL_ACTIONS: readonly TestSignalAction[] = TEST_SIGNAL_PATHS.map((path) => ACTIONS[path]);
